module.exports = __webpack_public_path__ + "static/media/08_a_background.f52688f4.jpg";